import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";

export function getCaseStudiesAnchor(tenant: Tenant): string {
	const pathMap = {
		[Locale.cs]: "pripadove-studie" as const,
	} satisfies LocalizedString;
	return pathMap[tenant.locale];
}
